import { CriteriaSubject } from './project/SuccessCriteria';

class Estimate {
  public estimateType: CriteriaSubject;
  public amount: number;

  constructor(estimateType: CriteriaSubject, amount: number) {
    this.estimateType = estimateType;
    this.amount = amount;
  }
}

export default Estimate;


// WEBPACK FOOTER //
// ./src/models/Estimate.ts